import GLightbox from 'glightbox';

// eslint-disable-next-line no-unused-vars
const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
});

